import { Patient } from "model/patient.model";
import { Address } from "common/models/Address";
import { Nomenclature } from "common/models/Nomenclature";
import { PatientTypeEnum } from "common/enums/PatientTypeEnum";
import { EFactEAttestEnum } from "common/enums/EFactEAttestEnum";
import { CoPaymentEnum } from "common/enums/CoPaymentEnum";
import { PaymentMethodEnum } from "common/enums/PaymentMethodEnum";

/** ---- Dispatch Types ---- */
export const LOAD_PATIENT_START = "LOAD_PATIENT_START";
export const LOAD_PATIENT_SUCCESS = "LOAD_PATIENT_SUCCESS";
export const LOAD_PATIENT_ERROR = "LOAD_PATIENT_ERROR";
export const LOAD_ADDRESS_START = "LOAD_ADDRESS_START";
export const LOAD_ADDRESS_SUCCESS = "LOAD_ADDRESS_SUCCESS";
export const LOAD_ADDRESS_ERROR = "LOAD_ADDRESS_ERROR";
export const LOGIN_CORILUS_PASSPORT = "LOGIN_CORILUS_PASSPORT";
export const CLOSE_PATIENT = "CLOSE_PATIENT";
export const SET_NUMBER_OF_PATIENTS = "SET_NUMBER_OF_PATIENTS";

export const SET_NOMENCLATURE_CODE = "SET_NOMENCLATURE_CODE";
export const SET_PATIENT_TYPE = "SET_PATIENT_TYPE";
export const SET_EFACT_EATTEST = "SET_EFACT_EATTEST";
export const SET_CO_PAYMENT = "SET_CO_PAYMENT";
export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
export const SET_PAYED_AMOUNT = "SET_PAYED_AMOUNT";

export const TARIFIED_TODAY_START = "TARIFIED_TODAY_START";
export const TARIFIED_TODAY = "TARIFIED_TODAY";

/** ---- Dispatch Interfaces ---- */
interface TarifiedTodayStart {
  type: typeof TARIFIED_TODAY_START;
}

interface TarifiedToday {
  type: typeof TARIFIED_TODAY;
  payload: boolean;
}

interface LoadPatientStartAction {
  type: typeof LOAD_PATIENT_START;
}

interface LoadPatientSuccessAction {
  type: typeof LOAD_PATIENT_SUCCESS;
  payload: Patient;
}

interface LoadPatientErrorAction {
  type: typeof LOAD_PATIENT_ERROR;
  payload: any;
}

interface LoadAddressStartAction {
  type: typeof LOAD_ADDRESS_START;
}

interface LoadAddressSuccessAction {
  type: typeof LOAD_ADDRESS_SUCCESS;
  payload: Address;
}
interface LoadAddressErrorAction {
  type: typeof LOAD_ADDRESS_ERROR;
}

interface ClosePatientAction {
  type: typeof CLOSE_PATIENT;
}

interface LoginCorilusPassport {
  type: typeof LOGIN_CORILUS_PASSPORT;
}

interface SetNumberOfPatientsAction {
  type: typeof SET_NUMBER_OF_PATIENTS;
  payload: number;
}

interface SetNomenclatureCode {
  type: typeof SET_NOMENCLATURE_CODE;
  payload: Nomenclature[];
}

interface SetPatientType {
  type: typeof SET_PATIENT_TYPE;
  payload: PatientTypeEnum;
}

interface SetEFactEAttest {
  type: typeof SET_EFACT_EATTEST;
  payload: EFactEAttestEnum;
}
interface SetCoPayment {
  type: typeof SET_CO_PAYMENT;
  payload: CoPaymentEnum;
}

interface SetPaymentMethod {
  type: typeof SET_PAYMENT_METHOD;
  payload: PaymentMethodEnum;
}

interface SetPayedAmount {
  type: typeof SET_PAYED_AMOUNT;
  payload: number;
}

export type PatientAction =
  | SetPayedAmount
  | SetPaymentMethod
  | ClosePatientAction
  | LoadPatientStartAction
  | LoadPatientSuccessAction
  | LoadPatientErrorAction
  | LoadAddressStartAction
  | LoadAddressSuccessAction
  | LoadAddressErrorAction
  | SetNumberOfPatientsAction
  | SetNomenclatureCode
  | SetCoPayment
  | SetPatientType
  | SetEFactEAttest
  | LoginCorilusPassport
  | TarifiedTodayStart
  | TarifiedToday;
